import React from 'react';
import { Experiment } from '../Experiment';
import { FormattedMessage } from '../Intl';
import StarRating from '@homeaway/react-star-rating';
import {
  AspectRatioCard,
  AspectRatioCardImage,
  AspectRatioCardTitle,
  AspectRatioCardText
} from '@homeaway/react-aspect-ratio-card';

const CNAME = 'Trending';

const TrendingCard = ({
  onClick,
  slpUrl,
  serpUrl,
  imageUrl,
  formattedRentalsCount,
  averageRating,
  formattedAveragePrice,
  location,
  name,
  cardAspectRatio
}) => (
  <a
    href={slpUrl || serpUrl}
    className={`${CNAME}__link`}
    onClick={onClick}
  >
    <AspectRatioCard aspectRatio={cardAspectRatio}>
      <AspectRatioCardImage data-slot={'figure'} imageUri={imageUrl.replace('${templateId}', 'hw6')} />
      <AspectRatioCardTitle data-slot={'caption'} title={name} />
      <div className={`${CNAME}__content`} data-slot={'content'}>
        <AspectRatioCardText text={location} />
        <Experiment name="ptaHpAditionalInfoTrendingDestinations">
          {valueAdd =>
            (
              valueAdd === 1 &&
              <FormattedMessage id={['key.vacationrentals', 'key.avgrating', 'key.avgprice']}>
                {(rentalsTotal, avgRating, avgPrice) => (
                  <div>
                    <span className={`${CNAME}__count`}>{`${formattedRentalsCount} ${rentalsTotal}`}</span>
                    <span className={`${CNAME}__rating`}>
                      <StarRating rating={averageRating} size={'sm'} />
                      <span className={`${CNAME}__rating-text`}>{avgRating}</span>
                    </span>
                    <span className={`${CNAME}__price`}>
                      <strong>{formattedAveragePrice}</strong>
                      <span className={`${CNAME}__price-label`}>{avgPrice}</span>
                    </span>
                  </div>
                )}
              </FormattedMessage>
            )}
        </Experiment>
      </div>
    </AspectRatioCard>
  </a>
);

TrendingCard.defaultProps = {
  cardAspectRatio: '4x3'
};

export default TrendingCard;



// WEBPACK FOOTER //
// ./src/universal/components/Trending/TrendingCard.js